"use client"
import { ComponentConfig } from "@measured/puck"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { FormCustomizeTour, RenderConfig } from "./RenderConfig"

export const CCAFormCustomizeTour: ComponentConfig<FormCustomizeTour> = {
  label: "CCA | Form Customize Tour",
  //@ts-ignore
  fields: {
    ...commonStylesProps,
  },
  defaultProps: {
    className: "",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
  },
  ...RenderConfig,
}
export { RenderConfig }
